import axios from 'axios';
import RoutesIndexes from 'modules/authModule/enums/RoutesIndexes';
import { message } from 'antd';
import { userRoles } from 'enums/userRoles';
import apiUrl from '../../../helpers/apiUrl';

interface createUserRequest {
  userName: string;
  password: string;
  email: string;
  avatar?: string;
  modules: string;
  isActive: boolean;
  role: userRoles;
}

interface updateUserRequest {
  username: string;
  name: string;
  password: string;
  modules: string;
  userId: string;
}

const createUser = async (data: createUserRequest): Promise<any> => {
  const token = localStorage.getItem('token');
  return axios
    .post(`${apiUrl()}backoffice/users`, data, {
      headers: {
        Authorization: `Bearer ${JSON.parse(<string>token)?.accessToken}`,
      },
    })
    .then((response) => {
      // @ts-ignore
      if (response.data.code === RoutesIndexes.CANNOT_CREATE_USER) {
        // @ts-ignore
        message.error(response.data.message);
      }
      if (response?.data) {
        return response.data;
      }
    })
    .catch((e) => {
      message.error(e.message);
    });
};

const getUserById = async (userId: string): Promise<any> => {
  const tokenString = localStorage.getItem('token');
  return axios
    .get(`${apiUrl()}backoffice/users/${userId}`, {
      headers: {
        Authorization: `Bearer ${JSON.parse(<string>tokenString)?.accessToken}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((e): any => {
      message.error(e.message);
      return false;
    });
};

const deleteUserById = async (userId: string): Promise<any> => {
  const tokenString = localStorage.getItem('token');
  return axios
    .delete(`${apiUrl()}backoffice/users/${userId}`, {
      headers: {
        Authorization: `Bearer ${JSON.parse(<string>tokenString)?.accessToken}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((e): any => {
      message.error(e.message);
      return false;
    });
};

const getUsers = async (): Promise<any> => {
  const tokenString = localStorage.getItem('token');
  return axios
    .get(`${apiUrl()}backoffice/users`, {
      headers: {
        Authorization: `Bearer ${JSON.parse(<string>tokenString)?.accessToken}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((e): any => {
      message.error(e.message);
      return false;
    });
};

const updateUser = async (user: updateUserRequest): Promise<any> => {
  const tokenString = localStorage.getItem('token');
  return axios
    .put(`${apiUrl()}backoffice/users/${user.userId}`, user, {
      headers: {
        Authorization: `Bearer ${JSON.parse(<string>tokenString)?.accessToken}`,
      },
    })
    .then((response) => {
      return response;
    })
    .catch((e): any => {
      message.error(e.message);
      return false;
    });
};

export { createUser, getUserById, getUsers, deleteUserById, updateUser };
